import { IconFilter2 } from '@calendly/ui/components/glyphs/IconFilter2'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import { colorIconActive, colorIconStandard } from '@calendly/ui/theme'

export const FilterMenuTriggerIcon = ({ selected = false, ...props }) => (
  <UiIcon
    icon={IconFilter2}
    size="small"
    color={selected ? colorIconActive : colorIconStandard}
    title=""
    {...props}
  />
)
